import { useEffect, useState } from "react";
import { fetchAllOrders } from "../loads/common";

let cache = null;
let pending = null;

/** Every order once per page load (POST /order_search/): only used for counts and the «новых за день» series. */
export default function useAllOrders() {
  const [orders, setOrders] = useState(cache);
  useEffect(() => {
    let live = true;
    if (cache) return undefined;
    if (!pending)
      pending = fetchAllOrders()
        .then((d) => {
          cache = d;
          return d;
        })
        .catch(() => [])
        .finally(() => {
          pending = null;
        });
    pending.then((d) => live && setOrders(d));
    return () => {
      live = false;
    };
  }, []);
  return orders;
}
